import { FETCH_PAGE } from "../actions/types";

export const pageReducer = (state = null, action) => {
  switch (action.type) {
    case FETCH_PAGE:
      return action.payload;
    default:
      return state;
  }
};
